<section class="content">
  <div class="content-block">
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <app-form-consultation
            (onGoToTab)="onGoToTab($event)">
          </app-form-consultation>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Hub prescriptions auto après consultation -->
<div *ngIf="showHubModal" class="ordo-modal-overlay">
  <div class="ordo-modal-container" (click)="$event.stopPropagation()">
    <app-prescription-hub
      [consultation]="savedConsultation"
      [beneficiaire]="hubBeneficiaire"
      (onClose)="closeHubModal()">
    </app-prescription-hub>
  </div>
</div>